import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { DepositContent } from '../../../components/PriceOverviewCard/components/Layout/index.js';
import { DEFAULT_LOCALE } from '../../../components/PriceOverviewCard/models.js';
import { Flex, HelpTooltip, LabelSmall, LabelXSmall } from '../../../primitives/index.js';
import { priceFormatter } from '../../../utils/index.js';
export const Fee = /*#__PURE__*/_styled(({
  locale = DEFAULT_LOCALE,
  price,
  displayPrice,
  context = 'excluded'
}) => {
  const {
    t
  } = useTranslation();
  return _jsx(DepositContent, {
    children: _jsxs(Flex, {
      direction: "row",
      justifyContent: "space-between",
      children: [_jsxs(Flex, {
        direction: "row",
        gap: "4px",
        children: [_jsx(LabelSmall, {
          color: "contentSecondary",
          children: t('priceOverviewCard:fees.title', {
            context
          })
        }), _jsx(HelpTooltip, {
          content: t('priceOverviewCard:fees.tooltip', {
            context
          })
        })]
      }), _jsxs(Flex, {
        gap: "global/small",
        alignItems: "end",
        children: [_jsx(LabelSmall, {
          color: "contentSecondary",
          children: priceFormatter(locale, displayPrice.currency).format(displayPrice.value)
        }), displayPrice.currency !== price.currency && _jsx(LabelXSmall, {
          children: priceFormatter(DEFAULT_LOCALE, price.currency).format(price.value)
        })]
      })]
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "elg0phe0"
} : {
  target: "elg0phe0",
  label: "Fee"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");